<template>
  <div
    class="login"
    style="
      min-height: 100vh;
      background-image: url(img/theme/header-background.png);
      background-size: cover;
      background-position: center top;
    "
  >
    <base-alert type="danger" dismissible :visible="error != ''">
      <span class="alert-inner--text">{{ $t(error) }}</span>
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </base-alert>
    <loading-panel :visible="loading"></loading-panel>
    <!-- Header -->
    <div
      class="
        header header-login
        bg-gradient-dark
        opacity-3
        py-7 py-lg-4
        pt-lg-5
      "
    >
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">
                {{ $t("generic.appName") }} {{ version }}
              </h1>
              <p class="text-lead text-white">
                {{ $t("admin.admindescription") }}
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="box-login">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-login border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5" align="center">
              <b-row>
                <b-col>
                  <b-link @click="SignIn()">
                    <b-img
                      class="icon-xl rounded-circle mt-2 mb-1"
                      alt="..."
                      src="./img/icons/common/microsoft.png"
                    />
                  </b-link>
                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col>
                  <small class="text-white font-weight-bold">{{
                    $t("admin.btnmfalogin")
                  }}</small>
                </b-col>
              </b-row>
              <div v-if="isAuthEmailEnabled">
                <div class="text-left text-muted mb-0">
                  <small class="text-white">{{ $t("admin.logindemo") }}</small>
                </div>
                <validation-observer
                  v-slot="{ handleSubmit }"
                  ref="formValidator"
                >
                  <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                    <base-input
                      alternative
                      class="mb-0"
                      name="Email"
                      :rules="{ required: true, email: true }"
                      prepend-icon="ni ni-email-83"
                      placeholder="Email"
                      v-model="model.email"
                    >
                    </base-input>

                    <div class="text-center">
                      <base-button
                        type="success"
                        native-type="submit"
                        class="mt-0 mb-2"
                        >{{ $t("admin.btnlogin") }}</base-button
                      >
                    </div>
                  </b-form>
                </validation-observer>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { PublicClientApplication } from "@azure/msal-browser";
import * as jwt from "jsonwebtoken";
import config from "../../config";

export default {
  data() {
    return {
      isAuthEmailEnabled: process.env.VUE_APP_AUTH_DEMO_ENABLED === "1",
      version: process.env.VUE_APP_BUILD_VERSION,
      model: {
        email: "",
      },
      error: "",
      loading: false,
    };
  },
  async created() {
    this.$msalInstance = new PublicClientApplication(
      this.$store.state.msalConfig
    );
  },
  async mounted() {
    const accounts = this.$msalInstance.getAllAccounts();
    if (accounts.length == 0) {
      await this.$store.dispatch("LogOut");
    } else {
      this.account = accounts[0];
      this.$emitter.emit("login", this.account);
      // let path = this.$route.query.redirect || 'home';
      // this.$router.push({ path: path });
      await this.$store.dispatch("LogOut");
      this.account = null;
    }
  },
  methods: {
    ...mapActions(["LogIn"]),
    async onSubmit() {
      this.error = "";
      if (!this.model.email) return;
      try {
        this.loading = true;
        var result = await this.LogIn({
          idToken: this.model.email,
        });
        if (result) {
          let path = this.$route.query.redirect || 'home';
          this.loading = false;
          this.$router.push({ path: path });
        } else {
          this.error = "alert.UserNotAuthorized";
          console.error("Register Falied");
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async SignIn() {
      this.loading = true;
      this.account = await this.$msalInstance
        .loginPopup({})
        .then(() => {
          const myAccounts = this.$msalInstance.getAllAccounts();
          this.$emitter.emit("login", this.account);
          return myAccounts[0];
        })
        .catch((error) => {
          this.loading = false;
          console.error(`error during authentication: ${error}`);
        });
      if (this.account) {
        var customToken = jwt.sign(
          {
            token: this.account.idTokenClaims,
          },
          config.secret,
          {
            expiresIn: config.expiresIn,
          }
        );
        try {
          this.error = "";
          var result = await this.LogIn({
            idToken: customToken,
          });
          if (result) {
            let path = this.$route.query.redirect || 'home';
            this.loading = false;
            this.$router.push({ path: path });
          } else {
            this.error = "alert.UserNotAuthorized";
            console.error("Register Falied");
            this.loading = false;
          }
        } catch (error) {
          this.loading = false;
          console.log(error);
        }
      }
      this.loading = false;
    },
  },
};
</script>
